import { useRouter } from 'next/router'
import React from 'react'

import { useLocalStorage } from '@/hooks/useLocalStorage'

export const useAnalytics = () => {
  return useLocalStorage('gyym:AnalyticsParams', {
    utmSource: undefined as string | undefined,
    utmMedium: undefined as string | undefined,
    utmCampaign: undefined as string | undefined,
  })
}

export const useAnalyticsParams = () => {
  const router = useRouter()
  const q = router.query
  const [storedParams] = useAnalytics()

  return {
    utmSource: (q['utm_source'] as string) ?? storedParams.utmSource,
    utmMedium: (q['utm_medium'] as string) ?? storedParams.utmMedium,
    utmCampaign: (q['utm_campaign'] as string) ?? storedParams.utmCampaign,
  }
}

export const useAnalyticsTrackingEffect = () => {
  const router = useRouter()
  const q = router.query
  const [, setStoredParams] = useAnalytics()

  const hasParams = Boolean(
    q['utm_campaign'] &&
      typeof q['utm_campaign'] === 'string' &&
      q['utm_medium'] &&
      typeof q['utm_medium'] === 'string' &&
      q['utm_source'] &&
      typeof q['utm_source'] === 'string',
  )

  React.useEffect(() => {
    if (!hasParams) return

    const newParams = {
      utmSource: (q['utm_source'] as string) ?? undefined,
      utmMedium: (q['utm_medium'] as string) ?? undefined,
      utmCampaign: (q['utm_campaign'] as string) ?? undefined,
    }

    setStoredParams(newParams)
  }, [hasParams, q, setStoredParams])
}
